// jQuery_T4NT(document).ready(function($) {

//      /**
//      * Variant selection changed
//      */
// 	  jQuery_T4NT( document ).on( "variant:change", function( evt, variant ) {
// 	    //console.log( variant );
// 	  });
// });


document.addEventListener('click', function (e) {
    // Open drawer
    const btn = e.target.closest('.shop-pro-add');

   if (btn) {
        const drawerId = btn.getAttribute('data-dwr-id');
        const drawer = document.getElementById(drawerId);
        const mainDrawer = drawer.closest('.shop-look-drawer.main-drawer')

        if (mainDrawer) mainDrawer.classList.add('act_opened');
        if (drawer) drawer.classList.add('act_opened');
       
        return;
    }

    // Close drawer
    const backBtn = e.target.closest('.back-btn');
    if (backBtn) {
        const targetDrawer = backBtn?.getAttribute('data-target-dwr');
        console.log(targetDrawer);
        
        if (targetDrawer) {
            document.querySelector(targetDrawer).classList.remove('act_opened');
        }
    }
});


document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.shop-look-image-wrap').forEach(function(slider){

    new Swiper(slider, {
      slidesPerView: 1,
      loop: true,

      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true
      },

      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev')
      }
    });

  });

});